common.View.create('Search::mobileButton', {

    onDOMLoad() {
        this.initSlideout();
    },

    initSlideout() {
        // Find trigger slideout element
        this.element.find('.triggerSlideout')
            .on('click', (event) => {
                // Slide out the menu
                $('body').find('.Search\\:\\:mobileBar .slideOutMenu')
                    .toggleClass('tw-translate-y-full')
                    .find('input')
                        .trigger('focus')
                        .end();
            });
    },

});